<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_vii"></a><strong>CONTENTS</strong></h2>
<p class="toc-chap"><a class="nounder" href="#/xhtml/author#author"><strong>AUTHOR’S NOTE</strong></a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/part01#ch01"><strong>MONEY</strong></a></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part02#ch02" title="Link target outside of Sample"><strong>DRUGS <span class="small">AND</span> ALCOHOL</strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part03#ch03" title="Link target outside of Sample"><strong>INSULTS</strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part04#ch04" title="Link target outside of Sample"><strong>CARS</strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part05#ch05" title="Link target outside of Sample"><strong>SEX <span class="small">AND</span> RELATIONSHIPS</strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part06#ch06" title="Link target outside of Sample"><strong>CRIME <span class="small">AND</span> WEAPONS</strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part07#ch07" title="Link target outside of Sample"><strong>FASHION</strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part08#ch08" title="Link target outside of Sample"><strong>SKILLS <span class="small">AND</span> PRIDE</strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part09#ch09" title="Link target outside of Sample"><strong>PEOPLE</strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/part10#ch10" title="Link target outside of Sample"><strong>PLACES</strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/ack#ack" title="Link target outside of Sample"><strong>ACKNOWLEDGMENTS</strong></span></p>
<p class="indent"><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?178fd745